import axios from 'axios';
import ManageStorage from 'src/shared/global/manageStorage';
import ServiceAuth from '../auth/authToken';

const agendaApiConfig = axios.create({
    baseURL: process.env.REACT_APP_API_AGENDA
});

agendaApiConfig.interceptors.request.use(
    async config => {
        config.headers = {
            'Authorization': `Bearer ${ManageStorage.getValueFromStorage("token")}`,
        }
        return config;
    },
    error => {
        Promise.reject(error)
    });

agendaApiConfig.interceptors.response.use((response) => {
    return response
}, async function (error) {
    const originalRequest = error.config;
    console.log("ERROR agendaAPI.interceptors => ", error);
    if (error?.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        const { data } = await ServiceAuth.authUserGuest({
            username: process.env.REACT_APP_USER_GUEST
        });
        console.log("ERROR agendaAPI.interceptors => TOKEN NUEVO => ", data.accessToken);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.accessToken;
        ManageStorage.setItemStorage("token", data.accessToken);
        return agendaApiConfig(originalRequest);
    }
    return Promise.reject(error);
});

export default agendaApiConfig;